import { Dialog } from "primereact/dialog";
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import Cards from "react-credit-cards";
import "react-credit-cards/lib/styles.scss";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { mask, unMask } from "remask";
import { useGeneral } from "../contexts/GeneralInfoContext";
import { useNegotiation } from "../contexts/NegotiationContext";
import { usePrivate } from "../contexts/PrivateInfoContext";

function CartaoCreditoDialog({ close, cartaoValidacao }) {
  const { today } = useGeneral();
  const { cartaoNumero, setCartaoNumero, cartaoRecusadoData } = useNegotiation();
  const { cartaoBandeira, setCartaoBandeira } = usePrivate();
  const [mostraErroBandeira, setMostraErroBandeira] = useState(false);
  const [cartaoNome, setCartaoNome] = useState("");
  const [cartaoVencimento, setCartaoVencimento] = useState("");
  const [cartaoCVC, setCartaoCVC] = useState("");
  const [campoFoco, setCampoFoco] = useState("");
  const [diaVencimento, setDiaVencimento] = useState("");
  const [anoVencimento, setAnoVencimento] = useState("");

  function ValidaVencimento(e) {
    const anoAtual = format(today, "yy");
    if (Number(e.slice(0, 2)) <= 12 && Number(e.slice(-2)) >= Number(anoAtual)) {
      setDiaVencimento(e.slice(0, 2));
      setAnoVencimento(e.slice(-2));
    } else {
      setCartaoVencimento("");
      toast.error("Vencimento Inválido!");
    }
  }

  function ValidaCartao(event) {
    event.preventDefault();

    const cardData = {
      card_number: unMask(cartaoNumero),
      holder_name: cartaoNome,
      security_code: cartaoCVC,
      expiration_month: diaVencimento,
      expiration_year: anoVencimento,
    };
    if (JSON.stringify(cartaoRecusadoData) === JSON.stringify(cardData))
      toast.warning(
        "Os dados do cartão informados estão iguais aos que já foram recusados anteriormente, por favor verifique seu cartão ou tente com um cartão diferente"
      );
    else cartaoValidacao(cardData);
  }

  function previneMudancaBandeira(e) {
    if (e !== cartaoBandeira) setMostraErroBandeira(true);
    else setMostraErroBandeira(false);
  }

  return (
    <Dialog
      visible
      header="Pagar com cartão de crédito"
      onHide={() => close()}
      style={{
        minHeigth: "70vh",
        minWidth: "30vw",
        textAlign: "center",
        borderRadius: "0.75rem",
      }}
      draggable={false}
      className="boletosDialog"
    >
      <div className="grid text-left">
        <div>
          <Cards
            cvc={cartaoCVC}
            expiry={cartaoVencimento}
            name={cartaoNome}
            number={cartaoNumero}
            focused={campoFoco}
            placeholders={{ name: "NOME" }}
            callback={(type) => {
              cartaoNumero.length > 12 && previneMudancaBandeira(type.issuer);
            }}
            locale={{ valid: "Válido até" }}
          />
        </div>
        <form onSubmit={(e) => ValidaCartao(e)}>
          <div className="flex flex-col mt-4 font-bold gap-2">
            <div className="flex flex-col">
              <label>Número do Cartão</label>
              {/* <InputMask
                    name="number"
                    value={cartaoNumero}
                    onFocus={e=>{setCampoFoco(e.target.name)}}
                    onChange={e=>{setCartaoNumero(e.value);console.log(cartaoNumero)}}
                    placeholder="ex: 9999 9999 9999 9999"
                    required
                    mask="9999 9999 9999 9999"
                    //tooltipOptions={}
                    unmask
                    /> */}
              <InputText
                name="number"
                value={cartaoNumero}
                onChange={(e) => {
                  setCartaoNumero(
                    mask(unMask(e.target.value), ["9999 999999 9999", "9999 999999 99999", "9999 9999 9999 9999"])
                  );
                }}
                placeholder="ex: 9999 9999 9999 9999"
                required
                onFocus={(e) => {
                  setCampoFoco(e.target.name);
                }}
              />
            </div>
            <div className="flex flex-col">
              <label>Nome Cartão(exatamente como o impresso no cartão)</label>
              <InputText
                name="name"
                value={cartaoNome}
                onFocus={(e) => {
                  setCampoFoco(e.target.name);
                }}
                onChange={(e) => setCartaoNome(e.target.value)}
                placeholder="ex: FERNANDO NUNES"
                required
              />
            </div>
            <div className="flex flex-col">
              <label>Vencimento do Cartão</label>
              <InputMask
                name="expiry"
                value={cartaoVencimento}
                onFocus={(e) => {
                  setCampoFoco(e.target.name);
                }}
                onChange={(e) => setCartaoVencimento(e.value)}
                onComplete={(e) => ValidaVencimento(e.value)}
                placeholder="ex: MM/AA"
                required
                mask="99/99"
              />
            </div>
            <div className="flex flex-col">
              <label>Código de Segurança (CVC/CVV)</label>
              <InputText
                name="cvc"
                value={cartaoCVC}
                onFocus={(e) => {
                  setCampoFoco(e.target.name);
                }}
                onChange={(e) => setCartaoCVC(e.target.value)}
                required
                placeholder="ex: 999"
              />
            </div>
            <div>
              {mostraErroBandeira && (
                <label className="text-red-600">*ERRO: Bandeira do cartão diferente da informada</label>
              )}
            </div>
            <div className="continueButton mt-2 ">
              {/* <Button label="Pagar" type="submit" /> */}
              <button
                className="bg-[#001d74] w-full h-[6vh] text-slate-50 p-2
                    hover:bg-gradient-to-b hover:from-[#0000ff] hover:to-[#0040ff] 
                    hover:shadow-[1.5px_1.5px_5px_5px_#4300fa85] transition duration-300
                    disabled:hover:from-[#001d74]/0 disabled:hover:to-[#001d74]/0 disabled:hover:shadow-none
                    text-[2.5vh] font-lato font-bold disabled:bg-[#001d74]/70 rounded-md mt-6"
                type="submit"
                disabled={mostraErroBandeira}
              >
                Pagar
              </button>
            </div>
          </div>
        </form>
      </div>
    </Dialog>
  );
}

export default CartaoCreditoDialog;
